function calculateReadability(content) {
  if (!content) {
    return {
      numCharacters: 0,
      numWords: 0,
      numSentences: 0,
      ARI: 0
    };
  }

  // 1️⃣ Remove HTML tags
  let plainText = content.replace(/<[^>]+>/g, '');

  // 2️⃣ Normalize spaces and newlines like LinkedIn does
  plainText = plainText
    .replace(/\r\n/g, '\n')   // normalize CRLF → LF
    .replace(/[ \t]+\n/g, '\n') // remove spaces before newline
    .replace(/\n{2,}/g, '\n') // collapse multiple newlines
    .trim();                  // trim start/end spaces

  let numCharacters = 0;
  let numWords = 0;
  let numSentences = 0;
  let ARI = 0;

  if (!plainText || plainText.length === 0) {
    return {
      numCharacters,
      numWords,
      numSentences,
      ARI
    };
  }

  // 3️⃣ Count characters in UTF-16 code units (LinkedIn internal measure)
  numCharacters = (() => {
    let len = 0;
    for (const ch of plainText) {
      const code = ch.codePointAt(0);
      len += code > 0xFFFF ? 2 : 1;
    }
    return len;
  })();

  // 4️⃣ Count words
  numWords = plainText.split(/\s+/).filter(Boolean).length;

  // 5️⃣ Count sentences
  numSentences = plainText.split(/[.!?]+|\n/).filter(Boolean).length;

  // 6️⃣ Calculate ARI
  ARI = 4.71 * (numCharacters / numWords) + 0.5 * (numWords / numSentences) - 21.43;

  let roundedARI = Math.ceil(ARI);
  if (roundedARI < 0) roundedARI = 0;
  if (roundedARI > 30) roundedARI = 0;

  return {
    numCharacters,
    numWords,
    numSentences,
    ARI: roundedARI
  };
}

export default calculateReadability;